var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "boss-resumecard-item-left",
      class: [
        { "boss-new": _vm.member.isNew },
        { "pega-input": _vm.isShowCheckbox },
      ],
      attrs: { "data-test": "resumecard-avatar" },
      on: {
        click: function ($event) {
          _vm.isShowCheckbox ? _vm.$emit("change", _vm.id) : ""
        },
      },
    },
    [
      _c("div", { staticClass: "text-center" }, [
        _c("span", { staticStyle: { display: "inline-flex" } }, [
          _vm.isShowCheckbox
            ? _c("input", {
                staticClass: "boss-userid pega-resumecard-check pega-input",
                staticStyle: { "margin-top": "2px" },
                attrs: {
                  id: "is-selected-" + _vm.id,
                  type: "checkbox",
                  "data-test": "is-selected",
                },
                domProps: { checked: _vm.check, value: _vm.id },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "boss-userid-text pega-resumecard-id pega-input",
              attrs: { "data-test": "user-id" },
            },
            [_vm._v("ID:" + _vm._s(_vm.member.id) + "\n      ")]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "boss-resumecard-item-left-item" }, [
        _c(
          "div",
          { staticClass: "boss-avatar" },
          [
            _vm.isScouted && !_vm.isMasking
              ? [
                  _c("span", {
                    class: [_vm.isReadScout ? "boss-read" : "boss-unread"],
                    attrs: { "data-test": "is-read-scout" },
                  }),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.isNew
              ? _c("img", {
                  staticClass: "boss-avatar-image",
                  attrs: {
                    "data-test": "boss-avatar-new",
                    src: require("@/assets/images/boss-avatar-new.svg"),
                    alt: "24時間以内",
                  },
                })
              : _c("img", {
                  staticClass: "boss-avatar-image",
                  attrs: {
                    "data-test": "boss-avatar",
                    src: require("@/assets/images/boss-avatar.svg"),
                    alt: "90日以上無し",
                  },
                }),
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "boss-latest-action" }, [
          _c("div", { staticClass: "boss-resumecard-head" }, [
            _vm._v("\n        最終ログイン\n      "),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "boss-resumecard-date",
              class: { "boss-over-days": !_vm.isNew },
              attrs: { "data-test": "member_last_activity" },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("loadLoginLabel")(_vm.lastActivityLabel)) +
                  "\n      "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "boss-another-scout" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: {
                    content: "7日以内にこの会員をスカウトした他社企業数です。",
                  },
                  expression:
                    "{ content: '7日以内にこの会員をスカウトした他社企業数です。'}",
                },
              ],
              staticClass: "boss-resumecard-head",
            },
            [_vm._v("\n        スカウト社数\n      ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "boss-resumecard-date",
              attrs: { "data-test": "approached-count" },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm._f("parseApproachedCount")(_vm.member.approachedCount)
                  ) +
                  "\n      "
              ),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }